module.exports = __webpack_public_path__ + "media/images/registrations/info_version/info-mobile-04-e858b5989228d148b7e4524fb3212941.png";